import { Trophy, Sparkles } from "lucide-react";

interface Props {
  lessonName: string;
  takeaway?: string | null;
  masteryPrinciple?: string | null;
}

export default function CompletionTakeaway({ lessonName, takeaway, masteryPrinciple }: Props) {
  if (!takeaway && !masteryPrinciple) return null;

  return (
    <div className="space-y-4">
      {takeaway && (
        <div className="rounded-2xl border border-accent/25 bg-accent/5 p-5 space-y-2">
          <div className="flex items-center gap-2">
            <Trophy className="h-4 w-4 text-accent" />
            <p className="text-[10px] font-heading font-semibold uppercase tracking-widest text-accent">
              Completion Takeaway
            </p>
          </div>
          <p className="font-body text-sm leading-[1.75] text-foreground/85">{takeaway}</p>
        </div>
      )}

      {masteryPrinciple && (
        <div className="rounded-2xl border border-primary/25 bg-primary/5 p-5 flex items-start gap-3">
          <Sparkles className="h-4 w-4 text-primary mt-0.5 shrink-0" />
          <div>
            <p className="text-[10px] font-heading font-semibold uppercase tracking-widest text-primary mb-1">
              Mastery Principle
            </p>
            <p className="font-heading text-sm font-semibold leading-relaxed text-foreground">
              {masteryPrinciple}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
